import { useMemo, useState } from "react";
import { liveRankRows, liveTabs, type LiveRankRow } from "@/mocks/homeData";

const stateStyle: Record<LiveRankRow["state"], string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-accent-500 text-background-50",
  新: "bg-secondary-200 text-secondary-900",
};

export default function LiveRank() {
  const [tab, setTab] = useState<string>("全部");

  const rows = useMemo(() => {
    if (tab === "全部") return liveRankRows;
    return liveRankRows.filter((r) => r.category === tab);
  }, [tab]);

  return (
    <section id="rank" className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <h3 className="font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
              实时热榜
            </h3>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
              <i className="ri-time-line"></i>
              每 5 分钟更新
            </span>
          </div>
          <p className="mt-3 text-sm text-foreground-500 md:text-base">
            谁在冲顶、谁在下滑，一眼看穿今天全网话题的攻防战。
          </p>
        </div>

        {/* tabs */}
        <div className="flex flex-wrap items-center gap-2">
          <div className="inline-flex items-center rounded-full border border-background-300 bg-background-50 p-1">
            {liveTabs.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(t)}
                className={`rounded-full px-3 py-1.5 text-xs whitespace-nowrap transition-colors md:px-4 md:text-sm ${
                  tab === t
                    ? "bg-foreground-950 text-background-50 font-medium"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* list */}
      <ol className="mt-8 divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
        {rows.map((row, idx) => (
          <li key={row.id}>
            <a
              href="#today"
              className="group flex items-center gap-3 px-4 py-4 transition-colors hover:bg-background-100/70 md:gap-5 md:px-6"
            >
              <span
                className={`w-6 shrink-0 text-center font-num text-2xl md:w-8 md:text-3xl ${
                  idx < 3 ? "text-primary-600" : "text-foreground-300 group-hover:text-foreground-500"
                }`}
              >
                {String(idx + 1).padStart(2, "0")}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="truncate text-sm font-medium text-foreground-900 md:text-base">
                    {row.title}
                  </p>
                  <span className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold ${stateStyle[row.state]}`}>
                    {row.state}
                  </span>
                </div>
                <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-400 md:text-xs">
                  <span className="hidden rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800 sm:inline">
                    {row.category}
                  </span>
                  <span className="truncate sm:block">{row.detail}</span>
                </div>
              </div>

              <div className="hidden w-36 md:block">
                <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500"
                    style={{ width: `${row.heat}%` }}
                  ></div>
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-4">
                <span className="font-num text-lg text-foreground-800 md:text-xl">{row.heat}</span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-300 text-foreground-500 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          </li>
        ))}
      </ol>

      <p className="mt-4 text-center text-xs text-foreground-400">
        榜单由公开讨论聚合计算，仅供娱乐参考 · 点击任一行查看话题详情
      </p>
    </section>
  );
}